import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/QR.png'


const _withScopeId = n => (_pushScopeId("data-v-0fa635dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "my-[40px] px-10" }
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "QR",
  class: "w-fit mb-4 pt-4"
}, null, -1))

import BaseReturn from '@/components/common/BaseReturn.vue';
import BaseTypography from '@/components/common/BaseTypography.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Requisites',
  setup(__props) {

const requisites = [
    {
        title: 'СБЕРБАНК',
        text: [
            'Получатель: ООО «РВМ»',
            'ОГРН: 1157847393373',
            'ИНН: 7840042552  КПП: 780201001',
            'Банковские реквизиты: Северо-Западный банк ПАО «Сбербанк»',
            'Р/с: 40702810655000057947',
            'К/с: 30101810500000000653',
            'БИК: 044030653',
        ],
    },
    {
        title: 'Т-БАНК (Возможна оплата по QR кредитками)',
        text: [
            'Получатель: ООО «РВМ»',
            'ОГРН: 1157847393373',
            'ИНН: 7840042552  КПП: 780201001',
            'Банковские реквизиты: АО «ТБанк»',
            'Р/с: 40702810610001844787',
            'К/с: 30101810145250000974',
            'БИК: 044525974',
        ],
    },
    {
        title: 'АЛЬФА-БАНК',
        text: [
            'Получатель: ООО «РВМ»',
            'ОГРН: 1157847393373',
            'ИНН: 7840042552  КПП: 780201001',
            'Банковские реквизиты: Филиал «Санкт-Петербургский» АО «Альфа-Банк»',
            'Р/с: 40702810532130016875',
            'К/с: 30101810600000000786',
            'БИК: 044030786',
        ],
    },
    {
        title: 'ВОЗВРАТ ОПЛАТЫ',
        text: [
            'Если у Вас появились причины для изменения условий Вашего бронирования или отмены тура, по Вашему заявлению вернём полную стоимость оплаченного Вами тура, или его часть, за вычетом фактически понесённых расходов и в зависимости от сроков отмены. Возврат рассматривается и рассчитывается индивидуально в каждом конкретном случае, в соответствии с условиями Вашего договора и условиями банка. Возврат переведённых денежных средств производится на Ваш банковский счёт в течении 5-30 рабочих дней (срок зависит от банка, который выдал Вам карту).',
        ],
    },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BaseReturn, {
      text: "Реквизиты",
      class: "!mb-[76px]"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseTypography, {
          text: "Оплата по СБП",
          type: "body2"
        }),
        _hoisted_4,
        _createVNode(BaseTypography, {
          text: "Для оплаты отсканируйте QR-код в мобильном приложении банка или штатной камерой телефона",
          type: "body"
        })
      ]),
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(requisites, (requisite) => {
        return _createElementVNode("div", {
          key: requisite.title,
          class: "item"
        }, [
          _createVNode(BaseTypography, {
            text: requisite.title,
            type: "body2"
          }, null, 8, ["text"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(requisite.text, (string) => {
            return (_openBlock(), _createBlock(BaseTypography, {
              key: string,
              text: string,
              type: "body"
            }, null, 8, ["text"]))
          }), 128))
        ])
      }), 64))
    ])
  ]))
}
}

})